import React from "react";
import { Outlet } from "react-router-dom";
import AuthNavbar from "components/Navbars/AuthNavbar.js";
import AuthFooter from "components/Footers/AuthFooter.js";
import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";

/**
 * Auth layout — wraps all /auth/* routes (login, forgot password, etc.)
 * In v6, nested routes are rendered via <Outlet /> rather than an internal <Routes>.
 * The actual route definitions live in index.js.
 */
function Auth() {
  return (
    <>
      <div className="wrapper wrapper-full-page">
        <AuthNavbar />
        {/* Renders whichever /auth/* child route matched */}
        <Outlet />
        <AuthFooter />
      </div>
      <FixedPlugin />
    </>
  );
}

export default Auth;
